import { Skeleton, SkeletonGroup } from '@/components/ui/Skeleton';
import type { LaunchInput } from '@/lib/execution-launch-inputs';

interface ExecutionLaunchInputsProps {
  inputs: LaunchInput[];
  loading?: boolean;
}

// Label / value rows read the same in a narrow column and on a full page.
const GRID_CLASS = 'mt-3 grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)] gap-x-4 gap-y-2';

/** What a run was launched with: one label / value pair per filled input. */
export const ExecutionLaunchInputs = ({ inputs, loading = false }: ExecutionLaunchInputsProps) => {
  if (loading && inputs.length === 0) {
    return (
      <SkeletonGroup
        label="Paramètres"
        className="rounded-[24px] border border-domino-cardBorder bg-domino-white px-5 py-4"
      >
        <Skeleton className="h-4 w-24" />
        <div className={GRID_CLASS}>
          {[0, 1, 2, 3].map((index) => (
            <div key={index} className="contents">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-28" />
            </div>
          ))}
        </div>
      </SkeletonGroup>
    );
  }
  if (inputs.length === 0) return null;

  return (
    <section className="rounded-[24px] border border-domino-cardBorder bg-domino-white px-5 py-4">
      <h4 className="text-sm font-semibold text-domino-ink">Paramètres</h4>
      <dl className={GRID_CLASS}>
        {inputs.map((input) => (
          <div key={input.key} className="contents">
            <dt className="text-sm text-domino-inkSoft">{input.label}</dt>
            <dd className="text-sm font-medium text-domino-ink break-words">
              {input.value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
